import { useAuth } from "contexts/AuthContext";
import { useEffect } from "react";

export default function GoogleSuccess() {
    const { loginWithGoogle } = useAuth();
  
    console.log("GoogleSuccess module loaded");

    useEffect(() => {
      const run = async () => {
        const params = new URLSearchParams(window.location.search);
  
        console.log(params);
        const token = params.get("token");
        const refreshToken = params.get("refreshToken");
  
        if (token && refreshToken) {
          await loginWithGoogle(token, refreshToken);
        }
      };
  
      run();
    }, [loginWithGoogle]);
  
    return <div>Signing you in…</div>;
  }
  